import { render, staticRenderFns } from "./checkStep3.vue?vue&type=template&id=fb833f66&"
import script from "./checkStep3.vue?vue&type=script&lang=js&"
export * from "./checkStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports